import { apiGetFeed, apiGetFilteredFeed, apiGetMore } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import CURSOR from '@/store/models/cursor';

// Services
import { mapEnabledToSlug } from '@/store/services/mapEnabledToSlug';

import app from '@/app';

// initial state
const state = {
  all: {
    data: [],
    meta: CURSOR
  },

  filters: {
    gameTypes: []
  },

  queue: []
};

// mutations
const mutations = {
  [types.RECEIVED_FEED](state, data) {
    state.all.data = data.data;
    state.all.meta = data.meta;
  },

  [types.APPEND_FEED](state, data) {
    data.data.forEach(function (obj) {
      state.all.data.push(obj);
    });

    state.all.meta = data.meta;
  },

  [types.PREPEND_FEED_ITEM](state, item) {
    state.all.data.unshift(item);
  },

  [types.QUEUE_FEED_ITEM](state, item) {
    state.queue.push(item);
  },

  [types.PREPEND_QUEUE](state, queueItems) {
    //reverse array so that the newest items are last to be inserted
    queueItems.reverse();

    //prepend the new items in feed
    queueItems.forEach((item, i) => {
      setTimeout(function () {
        state.all.data.unshift(item);

        //remove one by one from queue, since queueItems is clone of state.queue, 
        //length should be the same. this is done only for animated visual of countdown 
        //of pending messages
        state.queue.pop();
      }, i * 1000);
    })

    //state.queue = [];
  },

  [types.RECEIVED_FEED_GAMETYPES](state, gameTypes) {
    state.filters.gameTypes = gameTypes;
  },

  [types.UPDATE_FEED_GAMETYPE](state, gameType) {
    // find gametype in gameTypes and update enabled state
    state.filters.gameTypes.find((el) => {
      if (el.slug == gameType.slug) {
        el.enabled = gameType.enabled;
      }
    })
  },

  [types.DISABLE_ALL_FEED_GAMETYPES](state, gameType) {
    state.filters.gameTypes.forEach((el) => {
      el.enabled = false;
    })
  }
};

const actions = {
  getFeed: ({ commit }) => {
    return apiGetFeed().then(({ data }) => {
      var latest_seen_update = localStorage.getItem('latest_article_seen_timestamp');

      //loop through all the news items and check if they are new (unseen) or seen already
      data.data.forEach(function (obj) {
        var date_created = new Date(obj.created_at_timestamp * 1000);
        var date_now = new Date(Date.now());

        var difference = date_now.getTime() - date_created.getTime();
        var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);

        //if created more than 5 days
        //or created_at < latest_seen_update
        //then not new
        //else new
        obj.isNew = (daysDifference > 5 || obj.created_at_timestamp <= latest_seen_update)
          ? false
          : true;
      });

      let articles = data.data;
      //get those which are not new and push through feed
      data.data = articles.filter(article => article.isNew == false);
      commit(types.RECEIVED_FEED, data);
      //get those which are new and push through a different feed
      let newArticles = articles.filter(article => article.isNew == true);
      newArticles.forEach(function (obj) {
        commit(types.QUEUE_FEED_ITEM, obj);
      })

    })
      .catch((error) => {
        console.log(error);
      });
  },

  getMoreFeed: ({ commit }, url) => {
    return apiGetMore(url).then(({ data }) => {
      commit(types.APPEND_FEED, data);
    })
      .catch((error) => {
        console.log(error);
      });
  },

  prependFeedItem: ({ commit, rootState }, item) => {
    item.isNew = true;

    if (rootState.drawer.isDrawerActive || app.$mq('sm-max')) {
      // send items to queue
      commit(types.QUEUE_FEED_ITEM, item);
    } else {
      //if desktop, queue feed item too
      commit(types.QUEUE_FEED_ITEM, item);
      //commit(types.PREPEND_FEED_ITEM, item);
    }
  },

  prependQueueToFeed: ({ commit, state }) => {
    // If we have items in queue, let's add them to the main feed object 'all'
    if (state.queue.length) {
      // But first, let's make a temp object of what to prepend
      // as we're going to dump the queue when we prepend.
      // This should avoid issues if we dump before the prepend finishes
      let queueItems = state.queue;

      //get latest timestamp from the new items
      let latestTimestamp = Math.max.apply(Math, queueItems.map(function (o) { return o.created_at_timestamp; }));
      let latest_seen_update = localStorage.getItem('latest_article_seen_timestamp');

      //prepend the new items in feed
      queueItems.forEach((item) => {
        //here we can assume that all news is new, since it is pushed realtime,
        //but still making the checks for any corner case that may be created now 
        //or future changes
        var date_created = new Date(item.created_at_timestamp * 1000);
        var date_now = new Date(Date.now());

        var difference = date_now.getTime() - date_created.getTime();
        var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);

        //if created more than 5 days
        //or created_at < latest_seen_update
        //then not new
        //else new
        item.isNew = (daysDifference > 5 || item.created_at_timestamp <= latest_seen_update)
          ? false
          : true;
      })

      //assign latest feed timestamp to local storage so we 
      //know which is the last one the user saw
      localStorage.setItem('latest_article_seen_timestamp', latestTimestamp);

      commit(types.PREPEND_QUEUE, queueItems);
    }
  },

  toggleGameTypeFilter: ({ commit, state }, gameType) => {
    // Update the state
    commit(types.UPDATE_FEED_GAMETYPE, gameType);

    let request = mapEnabledToSlug(state.filters.gameTypes);

    // Then do the api call
    return apiGetFilteredFeed(request).then(({ data }) => {
      commit(types.RECEIVED_FEED, data);
    })
      .catch((error) => {
        console.log(error);
      });
  },

  disableAllGameTypeFilters: ({ commit, dispatch }) => {
    commit(types.DISABLE_ALL_FEED_GAMETYPES);
    dispatch('getFeed');
  }
};

const getters = {
  feed(state) {
    return state;
  },

  allFeedData(state) {
    return state.all.data;
  },

  allFeedMeta(state) {
    return state.all.meta;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/feed.js